import { NgModule } from '@angular/core';
import { DwsPermissionDirective } from './dws-permission.directive';

@NgModule({
  declarations: [DwsPermissionDirective],
  imports: [],
  exports: [DwsPermissionDirective]
})
export class DwsPermissionDirectiveModule {}
